<!--
@description: 支持快捷键操作的modal
esc 关闭弹窗
enter 确定按钮

@event
hide 触发弹窗关闭事件
ok 触发弹窗确定事件
-->
<template>
  <div>
    <byted-modal
      :class="className"
      v-model="modalValue"
      :title="title"
      :size="size"
      :mask-closable="maskClosable"
      :maskable="maskable"
      :mask-style="maskStyle"
      :dividing-line="dividingLine"
      :top="top"
      @hidden="$emit('hidden')"
      @show="$emit('show')"
      @shown="$emit('shown')"
      @input="$emit('input')"
    >
      <slot></slot>

      <template slot="header">
        <slot name="header"></slot>
      </template>

      <template slot="body">
        <slot name="body"></slot>
      </template>

      <template slot="footer">
        <slot name="footer"></slot>
      </template>
    </byted-modal>
  </div>
</template>

<script>
export default {
  name: 'support-shortcut-modal',
  data: function () {
    return {
      className: ''
    }
  },
  props: {
    title: {
      type: String
    },
    value: {
      type: Boolean
    },
    size: {
      type: String,
      default: 'default'
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    maskable: {
      type: Boolean,
      default: true
    },
    maskStyle: {
      type: Object,
      default: function () {
        return {}
      }
    },
    dividingLine: {
      type: Boolean,
      default: false
    },
    top: {
      type: String
    },
  },
  computed: {
    modalValue: {
      set (val) {
        if(!val)
        this.$emit('hide', false)
      },
      get () {
        return this.value
      }
    }
  },
  mounted: function () {
    this.className = this.$el.className
  },
  // 外部用 v-if 时，不会触发 watch
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
      // 监听弹窗是否可见
      if (val) {
        // 这个id 用于判断当前是否有显示的弹窗，否则不支持快捷键打开
        window.currentVisibleShortcutModalUid = this._uid
        // 弹窗可见，注册快捷键
        window.$shortcut.add('esc', () => {
          this.$emit('hide', true)
          this.$emit('input')
        })
        window.$shortcut.add('enter', () => {
          this.$emit('ok')
        },{ preventDefault: true, disableInInput: true })
      } else {
        window.currentVisibleShortcutModalUid = undefined
        // 弹窗不可见，取消快捷键
        window.$shortcut.remove('esc')
        window.$shortcut.remove('enter')
      }
    }
    }
  }
}
</script>
